import {AutoSolEnum} from 'main/analytics/gaTagsEnum';
import {GuidesEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {InstructionItem} from './types';

const {itemOne, itemTwo, seeHealthGuideAll, seeAccreditedNetwork} =
	translations['pt-br'].privateFlow.requestAuthorizations.newRequestInstructions;

export const INSTRUCTIONS_DISCLAIMER = itemTwo.description;

export const getInstructionsItems = (isNotredameSaude: boolean): InstructionItem[] => [
	{
		text: itemOne.inCaseOf,
		strongText: itemOne.urgencyAndEmergency,
		continuationText: itemOne.procedureAll,
		iconName: 'local-hospital-filled',
		action: {
			name: isNotredameSaude ? seeAccreditedNetwork : seeHealthGuideAll,
			dataTagId: AutoSolEnum.CLICK_VER_REDE_DE_ATENDIMENTO_AUTOSOL,
			navigateTo: GuidesEnum.SERVICE_NETWORK_HEALTH,
		},
	},
	{
		text: itemTwo.title,
		iconName: 'assignment-filled',
		bullets: itemTwo.bullets,
	},
];
